import { render } from "./tests-list.vue?vue&type=template&id=752ed261&scoped=true"
import script from "./tests-list.vue?vue&type=script&lang=js"
export * from "./tests-list.vue?vue&type=script&lang=js"

import "./tests-list.vue?vue&type=style&index=0&id=752ed261&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-752ed261"]])

export default __exports__